/**
 * A phone number as wa.me wants it: country code, digits only.
 *
 * The imported research lists store numbers the way Google prints them —
 * "090002 88855" — and a leading zero is how an Indian number is dialled
 * inside the country, never part of it. Left in, wa.me opens on an invalid
 * number and the chat never starts.
 */
export const waNumber = (phone: string): string => {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return '';
  const local = digits.replace(/^0+/, '');
  if (local.length === 10) return `91${local}`;
  // Already carries a country code (91xxxxxxxxxx, or someone else's).
  return local;
};
